import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, PlayCircle, Camera } from 'lucide-react';
const steps = [{
  icon: Scissors,
  title: 'Materiales fáciles de conseguir',
  desc: 'Usás limpiapipas/chenille y elementos simples que podés encontrar fácilmente.'
}, {
  icon: PlayCircle,
  title: 'Explicaciones claras',
  desc: 'Aprendés con guías visuales, pasos ordenados y apoyo en video para entender mejor cada movimiento.'
}, {
  icon: Camera,
  title: 'Resultados listos para mostrar',
  desc: 'Creá piezas lindas para decorar, regalar, publicar en redes o vender por encargo.'
}];
export function NoExperience() {
  return;
}